const createActionName =
  require('../../../data/util').createActionName('user/contact');
import Api from '../../../api/Api';

import Logger from '../../../utils/Logger';

let { id: module_id } = module;
const logger = new Logger(module_id);

// - start getting contacts (this is not called initally, only after updating contacts)
export const GET_HPA_CONTACTS = createActionName('GET_HPA_CONTACTS');
// - receive initial contacts
export const RECEIVE_HPA_CONTACTS = createActionName('RECEIVE_HPA_CONTACTS');
//  - get contacts failed
export const REQUEST_HPA_CONTACT_FAILED = createActionName(
  'REQUEST_HPA_CONTACT_FAILED'
);

//- start updating/adding contact
export const REQUEST_UPDATE_HPA_CONTACT = createActionName(
  'REQUEST_UPDATE_HPA_CONTACT'
);

// - updated/added contact.
// API returns updated contacts with the request so this payload includes them
export const RECEIVE_UPDATE_HPA_CONTACT = createActionName(
  'RECEIVE_UPDATE_HPA_CONTACT'
);

export const RECEIVE_UPDATE_HPA_INFO_NOTIFICATION = createActionName(
  'RECEIVE_UPDATE_HPA_INFO_NOTIFICATION'
);
export const REQUEST_UPDATE_HPA_INFO_NOTIFICATION = createActionName(
  'REQUEST_UPDATE_HPA_INFO_NOTIFICATION'
);
export const REQUEST_UPDATE_HPA_INFO_NOTIFICATION_FAILED = createActionName(
  'REQUEST_UPDATE_HPA_INFO_NOTIFICATION_FAILED'
);

//  - update/add contact failed
export const REQUEST_UPDATE_HPA_CONTACT_FAILED = createActionName(
  'REQUEST_UPDATE_HPA_CONTACT_FAILED'
);

export const REQUEST_REMOVE_HPA_CONTACT = createActionName(
  'REQUEST_REMOVE_HPA_CONTACT'
);
export const RECEIVE_REMOVE_HPA_CONTACT = createActionName(
  'RECEIVE_REMOVE_HPA_CONTACT'
);
export const REQUEST_REMOVE_HPA_CONTACT_FAILED = createActionName(
  'REQUEST_REMOVE_HPA_CONTACT_FAILED'
);

export const RESET_ERROR = createActionName('RESET_ERROR');

export const RECEIVE_IS_FIRST_TIME_HPA = createActionName(
  'RECEIVE_IS_FIRST_TIME_HPA'
);

export const receiveHpaContacts = (data) => ({
  type: RECEIVE_HPA_CONTACTS,
  payload: { data },
});

export const requestHpaContactFailed = (error) => ({
  type: REQUEST_HPA_CONTACT_FAILED,
  payload: { error },
});

export const requestUpdateHpaContact = () => ({
  type: REQUEST_UPDATE_HPA_CONTACT,
});

export const receiveUpdateHpaContact = () => ({
  type: RECEIVE_UPDATE_HPA_CONTACT,
});

export const requestUpdateHpaContactFailed = (error) => ({
  type: REQUEST_UPDATE_HPA_CONTACT_FAILED,
  payload: { error },
});

export const requestRemoveHpaContact = () => ({
  type: REQUEST_REMOVE_HPA_CONTACT,
});

export const receiveRemoveHpaContact = () => ({
  type: RECEIVE_REMOVE_HPA_CONTACT,
});

export const requestRemoveHpaContactFailed = (error) => ({
  type: REQUEST_REMOVE_HPA_CONTACT_FAILED,
  payload: { error },
});

export const receiveUpdateHpaInfoNotification = (data) => ({
  type: RECEIVE_UPDATE_HPA_INFO_NOTIFICATION,
  payload: { data },
});
export const requestUpdateHpaInfoNotification = () => ({
  type: REQUEST_UPDATE_HPA_INFO_NOTIFICATION,
});

export const requestUpdateHpaInfoNotificationFailed = (error) => ({
  type: REQUEST_UPDATE_HPA_INFO_NOTIFICATION_FAILED,
  payload: { error },
});
export const resetError = () => ({
  type: RESET_ERROR,
});

export const isFirstTimeHpa = (data) => ({
  type: RECEIVE_IS_FIRST_TIME_HPA,
  payload: { data },
});

export const doUpdateHpaContact =
  (formData) => (dispatch, getState, services) => {
    return new Promise((resolve, reject) => {
      dispatch(requestUpdateHpaContact());
      services.api
        .updateHpaContact({ payload: formData })
        .then(() => {
          dispatch(doGetHpaContact());
          return resolve(dispatch(receiveUpdateHpaContact()));
        })
        .catch((err) => {
          let errorCode = 'error';

          if (err.code) {
            errorCode += `.${err.code}`;
          }

          return reject(dispatch(requestUpdateHpaContactFailed(err)));
        });
    });
  };

export const doRemoveHpaContact = () => (dispatch, getState, services) => {
  return new Promise((resolve, reject) => {
    dispatch(requestRemoveHpaContact());
    services.api
      .removeHpaContact()
      .then(() => {
        dispatch(doGetHpaContact());
        return resolve(dispatch(receiveRemoveHpaContact()));
      })
      .catch((err) => {
        console.error(err);
        return reject(dispatch(requestRemoveHpaContactFailed(err)));
      });
  });
};

export const doGetFirstTimeHpa = () => (dispatch, getState, services) => {
  return new Promise((resolve, reject) => {
    services.api
      .isFirstTimeHpaSession()
      .then((userData) => {
        resolve(dispatch(isFirstTimeHpa(userData)));
      })
      .catch((err) => {
        console.error(err);
        return reject(dispatch(requestUpdateHpaInfoNotificationFailed(err)));
      });
  });
};

export const doUpdateHpaInfoNotification =
  () => (dispatch, getState, services) => {
    return new Promise((resolve, reject) => {
      services.api
        .updateFirstTimeHpaSession()
        .then(() => {
          dispatch(requestUpdateHpaInfoNotification());
        })
        .catch((err) => {
          console.error(err);
          return reject(dispatch(requestUpdateHpaInfoNotificationFailed(err)));
        });
    });
  };

export const doGetHpaContact = () => (dispatch, getState, services) => {
  services.api
    .getHpaContact()
    .then((data) => {
      dispatch(receiveHpaContacts(data));
    })
    .catch((err) => {
      console.error(err);
      dispatch(requestHpaContactFailed(err));
    });
};
